import type { SVGProps } from "react";
export interface CableCarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CableCarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CableCarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.875 8c0-.132.027-.257.069-.375H9.812l-.245.731a1.125 1.125 0 1 1-2.134-.712l.386-1.157.101-.239c.277-.53.828-.873 1.44-.873h1.515V4.328l-4.69.782a1.126 1.126 0 0 1-.37-2.22l12-2a1.127 1.127 0 0 1 .37 2.22l-5.06.843v1.422h1.515c.612 0 1.163.343 1.44.873l.1.24.387 1.156a1.126 1.126 0 0 1-2.134.712l-.245-.73h-1.132c.042.117.069.242.069.374v5.876H21l.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006H3a1.125 1.125 0 0 1 0-2.25h7.875z"
      />
      <path
        fill={color}
        d="M19.875 15c0-1.879-1.05-3.859-1.887-5.12l-.341-.495c-.106-.148-.304-.26-.567-.26H6.92a.73.73 0 0 0-.47.157l-.097.103C5.497 10.573 4.125 12.853 4.125 15s1.373 4.426 2.228 5.615l.097.102a.73.73 0 0 0 .47.157h10.16c.264 0 .46-.112.567-.26l.341-.495c.836-1.261 1.887-3.24 1.887-5.12Zm2.25 0c0 2.554-1.356 5.008-2.285 6.4l-.366.53c-.576.8-1.49 1.195-2.394 1.195H6.92c-.848 0-1.704-.348-2.282-1.05l-.112-.145c-.88-1.224-2.65-4.012-2.651-6.93 0-2.917 1.77-5.705 2.651-6.93l.112-.144c.578-.703 1.434-1.05 2.282-1.05h10.16c.904 0 1.818.395 2.394 1.195l.366.53c.929 1.393 2.285 3.847 2.285 6.4Z"
      />
    </svg>
  );
}
